// payment/terms/privacy 개인정보처리방침
import "./PrivacyTermPage.css";

const PaymentPrivacyTermPage = () => {
  return (
    <div className="privacy-policy">
      <h1>개인정보처리방침</h1>

      <p>
        이규호사주TV(이하 "회사")의 프리미엄 사주 서비스는 고객의 개인정보보호를
        중요시하며, 정보통신망 이용촉진 및 정보보호에 관한 법률을 준수하고
        있습니다. 회사의 개인정보보호정책은 정부의 법률 및 지침이 변경될 경우
        또는 회사의 이용자 관리 지침이 변할 경우 개정될 수 있으며, 개정사항은
        사이트에 게시를 통하여 공지할 것 입니다.
      </p>

      <h2>1. 개인정보의 수집항목 및 수집방법</h2>
      <p>
        ① 회사는 프리미엄 사주 상담, 영상 사주 서비스의 제공을 위해 아래와 같은
        개인정보를 수집하고 있습니다.
      </p>
      <ul>
        <li>사주 상담 정보 : 생년월일, 성별, 태어난 시간</li>
        <li>이용자 정보 : 이메일, 휴대폰번호</li>
      </ul>

      <p>
        ② 서비스 이용과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다.
      </p>
      <ul>
        <li>
          서비스 이용기록, 접속 IP정보, 쿠키, 결제기록, 이용정지기록, 접속로그
        </li>
      </ul>

      <p>
        ③ 유료서비스 이용 과정에서 아래와 같은 결제 정보들이 수집될 수 있습니다.
      </p>
      <ul>
        <li>은행계좌정보, 신용카드정보, 휴대폰정보 등</li>
      </ul>

      <p>
        ④ 회사는 이용자가 제공한 모든 정보를 약관에 명시한 목적 이외에 어떠한
        용도로도 사용되지 않으며, 추가 정보가 필요할 경우 반드시 이용자에게 사전
        동의를 구합니다.
      </p>

      <h2>2. 개인정보의 수집 및 이용목적</h2>
      <p>① 회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
      <ul>
        <li>
          서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 (콘텐츠
          제공, 구매 및 요금결제, 금융거래 본인 인증 및 금융 서비스)
        </li>
      </ul>

      <p>
        ② 그 외 아래 목적에 따라 개인정보를 이용할 수 있으며, 이 경우 관련
        법령에 따른 고지 및 동의를 받습니다.
      </p>
      <ul>
        <li>고객문의 응대, 콘텐츠 오류 분석 및 서비스 품질 개선</li>
        <li>이벤트, 광고성 정보 제공 및 마케팅 활용 (사전 동의 시)</li>
        <li>서비스 이용에 따른 통계 분석, 맞춤형 서비스 제공</li>
      </ul>

      <h2>3. 개인정보의 보유 및 이용기간</h2>
      <p>
        ① 이용자의 개인정보는 회사가 제공하는 서비스를 받는 동안 회사에서 계속
        보유하며, 서비스 제공을 위해 이용하게 됩니다. 서비스 종료 후에는 수집된
        개인정보가 열람 또는 이용될 수 없도록 파기합니다. 다만, 관계법령의
        규정에 의하여 보존할 필요성이 있는 경우에는 관계법령에 따라 보존합니다.
      </p>

      <p>
        ② 상법 및 '전자상거래 등에서의 소비자보호에 관한 법률' 등 관련 법령의
        규정에 의하여 다음과 같이 거래 관련 권리 의무 관계의 확인 등을 이유로
        일정기간 개인정보를 보존합니다.
      </p>
      <ul>
        <li>계약 또는 청약철회 등에 관한 기록 : 5년</li>
        <li>대금결제 및 재화 등의 공급에 관한 기록 : 5년</li>
        <li>소비자의 불만 또는 분쟁처리에 관한 기록 3년</li>
        <li>인터넷 로그기록자료, 접속자 추적자료 : 3개월</li>
      </ul>

      <h2>4. 개인정보의 파기절차 및 방법</h2>
      <p>
        ① 파기절차는 이용자의 서비스 제공 및 문의 대응 등을 위해 입력한 정보는
        목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라
        일정 기간 저장된 후 파기됩니다. 개인정보는 법률에 의한 경우가 아니고서는
        보유되는 목적 이외의 다른 목적으로 이용되지 않습니다.
      </p>

      <p>
        ② 파기방법은 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여
        파기하고, 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는
        기술적 방법을 사용하여 삭제합니다.
      </p>

      <h2>5. 개인정보의 제3자 제공 및 공유</h2>
      <p>
        회사는 이용자의 개인정보를 타 기업, 기관에 제공하지 않습니다. 단, 다음의
        경우는 예외로 합니다.
      </p>
      <ul>
        <li>이용자로부터 별도의 동의를 받은 경우</li>
        <li>
          관계법령의 규정에 의거하거나 수사상의 목적으로 관계기관으로부터의
          요구가 있을 경우
        </li>
      </ul>

      <h2>6. 개인정보의 취급위탁</h2>
      <p>
        회사는 서비스 향상을 위해 이용자의 개인정보를 위탁업체에 수집, 취급,
        관리 등을 위탁할 수 있으며, 관계 법령에 따라 위탁 계약 시 개인정보가
        안전하게 관리 될 수 있도록 필요한 사항을 규정하고 있습니다. 또한,
        공유하는 정보는 해당 목적을 달성하기 위하여 필요한 최소한의 정보에
        국한됩니다.
      </p>
      <ul>
        <li>
          수탁자 : 포트원, 나이스페이먼츠(전자결제 대행) / AWS : Amazon Web
          Service (서버관리 및 운영)
        </li>
      </ul>

      <h2>7. 개인정보의 자동 수집 장치의 설치, 운영 및 그 거부에 관한 사항</h2>
      <p>
        회사는 이용자의 정보를 수시로 저장하고 찾아내는 쿠키(cookie)등
        개인정보를 자동으로 수집하는 장치를 설치, 운용합니다. 쿠키는 웹사이트를
        운영하는데 이용되는 서버가 이용자의 컴퓨터로 전송되는 아주 작은 텍스트
        파일로써 이용자의 컴퓨터 하드디스크에 저장됩니다.
      </p>

      <p>① 쿠키 등 사용 목적</p>
      <ul>
        <li>
          이용자의 접속 빈도나 방문 시간 등을 분석, "이용자"의 관심분야를 파악
          및 자취 추적, 각종 이벤트 참여 정도 및 방문 횟수 파악 등을 통한 타겟
          마케팅 및 개인 맞춤 서비스 제공
        </li>
      </ul>

      <p>
        ② 이용자는 쿠키 설치 및 수집에 대해 자율적으로 선택할 수 있습니다.
        따라서, 이용자는 쿠키를 허용하거나 저장을 거부할 수 있습니다.
      </p>

      <p>③ 쿠키 설정 거부 방법</p>
      <ul>
        <li>
          웹 브라우저 상단의 '도구'메뉴 → '인터넷옵션' → '개인정보' → '고급' →
          쿠키 허용 여부 선택
        </li>
      </ul>
      <p>
        단, 쿠키의 저장을 거부할 경우 로그인이 필요한 일부 서비스의 이용에
        제한이 생길 수 있습니다.
      </p>

      <h2>8. 이용자 및 법정대리인의 권리와 그 행사방법</h2>
      <p>
        사용자는 언제든지 자신의 개인정보에 접근하거나 수정, 삭제를 요청할 수
        있습니다. 이를 위해 웹페이지 내 "문의하기"를 통해 당사에 연락할 수
        있습니다. 혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로
        연락하시면 조치하겠습니다.
      </p>

      <p>
        만 14세 미만의 아동은 개인정보 제공 시 법정대리인의 동의를 받아야 하며,
        법정대리인은 아동의 개인정보에 대한 열람, 정정, 삭제 등을 요청할 수
        있습니다. 회사는 법정대리인의 요청이 있을 경우 지체 없이 필요한 조치를
        취합니다.
      </p>

      <p>
        이용자는 본인의 개인정보에 대해 열람, 정정, 삭제, 처리정지를 요청할 수
        있으며, 회사는 법령에 따라 지체 없이 조치합니다. 이러한 요청은
        이메일(s295@naver.com), 문의하기 링크 또는 기타 수단을 통해 접수할 수
        있습니다.
      </p>

      <h2>9. 개인정보 관리 문의처 정보</h2>
      <p>
        회사는 이용자의 개인정보를 보호하고 그와 관련된 불만을 처리하기 위하여
        아래와 같이 개인정보 보호책임자 및 담당자를 지정하고 있습니다.
      </p>

      <div className="contact-info">
        <h3>개인정보 보호책임자</h3>
        <ul>
          <li>
            <strong>이름:</strong> 이규호
          </li>
          <li>
            <strong>이메일:</strong> s295@naver.com
          </li>
          <li>
            <strong>문의처:</strong> https://pf.kakao.com/_WQzFn
          </li>
        </ul>
      </div>

      <div className="agency-list">
        <h3>
          기타 개인정보침해에 대한 신고 또는 상담이 필요한 경우에는 아래
          기관으로 문의하시기 바랍니다.
        </h3>
        <ul>
          <li>
            개인정보침해신고센터 (http://privacy.kisa.or.kr, 국번없이 118)
          </li>
          <li>
            대검찰청 사이버범죄수사단 (http://www.spo.go.kr, 02-3480-3571)
          </li>
          <li>경찰청 사이버테러대응센터 (http://www.ctrc.go.kr, 1566-0112)</li>
        </ul>
      </div>

      <h2>10. 고지의 의무</h2>
      <p>
        개인정보취급방침은 정부의 정책 또는 보호조치 등의 회사정책 변경에 따라
        내용의 추가, 삭제 및 수정이 있을 시에는 변경되는 개인정보취급방침을
        시행하기 7일 전에 사이트를 통해 고지할 것 입니다.
      </p>

      <div className="effective-date">
        개인정보취급방침 시행일자 : 2025년 7월 11일
      </div>
    </div>
  );
};

export default PaymentPrivacyTermPage;
